/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.6.26",
    versionName: "0.4.0-nightly.2026.6.26",
    versionChannel: "nightly",
    buildDate: "2026-06-26T00:38:15.649Z",
    commitHash: "eb54053918bc30645d5360415e8f19159072e2cb",
};
